/* ============================================================
   LXRYWOOD Flächenrechner — Produktseiten-Block
   Vanilla JS. Keine Library, kein CDN.

   Grundsätze:
   - Alle Preise/Längen/Verfügbarkeiten kommen aus dem Varianten-JSON.
     KEIN Preis-Literal im Code.
   - Längenwahl über Kostenvergleich (niedrigster Warenwert;
     bei Gleichstand weniger Verschnitt).
   - Formular-Sync über die Options-Inputs des Themes
     (Radio name="<Option>" / Select name="options[<Option>]"),
     Events mit bubbles:true — die Variantenlogik des Themes bleibt Herr.
   - Scroll-Lock / Focus-Trap: globale Theme-Utilities werden genutzt.

   ACHTUNG Versand: ship_base_* / threshold_* sind Block-Settings und
   müssen manuell mit dem Shopify-Versandprofil synchron gehalten werden.
   Weicht das ab, zeigt der Rechner einen Betrag, den der Checkout nicht
   bestätigt. Deshalb Versand als „voraussichtlich" gekennzeichnet.
   ============================================================ */
(function () {
  "use strict";

  var euroCache = {};
  function euro(currency, cents) {
    var key = currency;
    if (!euroCache[key]) {
      euroCache[key] = new Intl.NumberFormat("de-DE", {
        style: "currency",
        currency: currency || "EUR",
      });
    }
    return euroCache[key].format(cents / 100);
  }
  var num2 = new Intl.NumberFormat("de-DE", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  /* Eingebaute Fallback-Holztöne (nur wenn weder native Swatch noch
     Block-Setting eine Farbe liefern). Hex hier ist zulässig: der Auftrag
     erlaubt Holzton-Hex ausdrücklich (Design §10). */
  var TONE_FALLBACK = {
    "eiche natur geölt": "#c9ab7f",
    "eiche walnuss geölt": "#8a6a4a",
    "eiche schwarz geölt": "#2e2b28",
    "eiche natur lackiert": "#cdae82",
    "walnuss natur lackiert": "#6f5236",
    "eiche rustik geölt": "#a98d68",
  };
  var TONE_NEUTRAL = "#c8b48f"; /* neutraler Sandton für Unbekanntes */

  function parseNum(v, fallback) {
    var n = parseFloat(String(v == null ? "" : v).replace(",", "."));
    return isFinite(n) ? n : fallback;
  }
  function parseLen(sizeValue) {
    if (sizeValue == null) return NaN;
    var m = String(sizeValue).match(/(\d+([.,]\d+)?)/);
    return m ? parseFloat(m[1].replace(",", ".")) : NaN;
  }

  function initRoot(root) {
    if (root.dataset.lxryInit === "1") return;
    root.dataset.lxryInit = "1";

    var config, variants, optionsData;
    try {
      config = JSON.parse(
        root.querySelector("[data-lxry-calc-config]").textContent
      );
      variants = JSON.parse(
        root.querySelector("[data-lxry-calc-variants]").textContent
      );
      optionsData = JSON.parse(
        root.querySelector("[data-lxry-calc-options]").textContent
      );
    } catch (e) {
      root.style.display = "none";
      return;
    }

    var sectionId = config.sectionId;
    var currency = config.currency || "EUR";
    var sizeName = (config.optionNames && config.optionNames.size) || "Größe";
    var woodName = (config.optionNames && config.optionNames.wood) || "Holzart";

    /* Optionsreihenfolge → Index in variant.options */
    var optIndex = {};
    var feltName = null;
    optionsData.forEach(function (opt, i) {
      var idx = typeof opt.position === "number" ? opt.position - 1 : i;
      optIndex[opt.name] = idx;
      if (opt.name !== sizeName && opt.name !== woodName && feltName === null) {
        feltName = opt.name;
      }
    });
    if (!(sizeName in optIndex) || !(woodName in optIndex)) {
      root.style.display = "none";
      return;
    }

    /* Geometrie */
    var PW = parseNum(config.geometry && config.geometry.panelWidth, 60);
    if (!(PW > 0)) PW = 60;
    var SLAT = parseNum(config.geometry && config.geometry.slatPitch, 6.7);
    if (!(SLAT > 0)) SLAT = 6.7;
    var slatsPerPanel = Math.max(1, Math.round(PW / SLAT));
    var effPitch = PW / slatsPerPanel;

    /* Längen aus den Größen-Optionswerten ableiten (Muster/NaN raus) */
    var sizeValueByLen = {};
    var lengths = [];
    (function () {
      var sizeOpt = null;
      optionsData.forEach(function (o) {
        if (o.name === sizeName) sizeOpt = o;
      });
      var values = [];
      if (sizeOpt && sizeOpt.values) {
        sizeOpt.values.forEach(function (v) {
          values.push(typeof v === "string" ? v : v && v.name ? v.name : String(v));
        });
      }
      values.forEach(function (val) {
        var L = parseLen(val);
        if (isFinite(L) && !/muster/i.test(val)) {
          if (!(L in sizeValueByLen)) {
            sizeValueByLen[L] = val;
            lengths.push(L);
          }
        }
      });
      lengths.sort(function (a, b) {
        return a - b;
      });
    })();
    if (!lengths.length) {
      root.style.display = "none";
      return;
    }

    /* Muster-Größenwert (für Muster-Ausstieg) */
    var musterSizeValue = null;
    (function () {
      var sizeOpt = null;
      optionsData.forEach(function (o) {
        if (o.name === sizeName) sizeOpt = o;
      });
      if (sizeOpt && sizeOpt.values) {
        sizeOpt.values.forEach(function (v) {
          var name = typeof v === "string" ? v : v && v.name ? v.name : String(v);
          if (/muster/i.test(name)) musterSizeValue = name;
        });
      }
    })();

    /* Shipping-Settings */
    var shipBase240 = parseNum(config.shipping && config.shipping.base240, 99.95);
    var shipBase300 = parseNum(config.shipping && config.shipping.base300, 149.95);
    var thHalf = parseNum(config.shipping && config.shipping.thresholdHalf, 1250);
    var thFree = parseNum(config.shipping && config.shipping.thresholdFree, 2500);
    function shipBaseFor(len) {
      return len <= 240 ? shipBase240 : shipBase300;
    }

    /* ---------- Holzton-Farbkaskade ---------- */
    var toneSettingMap = {};
    (function () {
      var raw = config.woodTones || "";
      String(raw)
        .split("\n")
        .forEach(function (line) {
          var parts = line.split("|");
          if (parts.length >= 2) {
            var name = parts[0].trim().toLowerCase();
            var hex = parts[1].trim();
            if (name && hex) toneSettingMap[name] = hex;
          }
        });
    })();
    var toneUnknownWarned = {};
    function woodColor(woodValue) {
      if (!woodValue) return TONE_NEUTRAL;
      var swatch = config.woodSwatches && config.woodSwatches[woodValue];
      if (swatch) return swatch;
      var key = woodValue.toLowerCase();
      if (toneSettingMap[key]) return toneSettingMap[key];
      if (TONE_FALLBACK[key]) return TONE_FALLBACK[key];
      if (config.designMode && !toneUnknownWarned[key]) {
        toneUnknownWarned[key] = true;
        // Sichtbarer Hinweis im Theme-Editor
        // eslint-disable-next-line no-console
        console.warn(
          "[LXRY Flächenrechner] Kein Holzton-Hex für „" +
            woodValue +
            "“ gefunden (weder Swatch noch Setting noch Fallback). Neutraler Sandton wird genutzt. Bitte in den Block-Einstellungen unter „Holztöne“ eine Zeile „" +
            woodValue +
            "|#hexwert“ ergänzen."
        );
      }
      return TONE_NEUTRAL;
    }

    /* ---------- DOM refs ---------- */
    var $ = function (sel) {
      return root.querySelector(sel);
    };
    var sheet = $("[data-lxry-sheet]");
    var backdrop = $("[data-lxry-backdrop]");
    var openBtn = $("[data-lxry-open]");
    var closeBtn = $("[data-lxry-close]");
    var bodyEl = $("[data-lxry-body]");
    var wInput = $("[data-lxry-w]");
    var hInput = $("[data-lxry-h]");
    var tonesWrap = $("[data-lxry-tones]");
    var toneDots = Array.prototype.slice.call(
      root.querySelectorAll("[data-lxry-wood]")
    );
    var toneNameEl = $("[data-lxry-tone-name]");
    var wallEl = $("[data-lxry-wall]");
    var presetsWrap = $("[data-lxry-presets]");
    var applyBtn = $("[data-lxry-apply]");
    var applyTxt = $("[data-lxry-apply-txt]");
    var sampleBtn = $("[data-lxry-sample]");
    var switchEl = $("[data-lxry-switch]");

    var elCount = $("[data-lxry-count]");
    var elCountLabel = $("[data-lxry-count-label]");
    var elArea = $("[data-lxry-area]");
    var elFmt = $("[data-lxry-fmt]");
    var elGoods = $("[data-lxry-goods]");
    var elShipLabel = $("[data-lxry-ship-label]");
    var elShip = $("[data-lxry-ship]");
    var elM2 = $("[data-lxry-m2]");
    var elTotal = $("[data-lxry-total]");
    var elCompare = $("[data-lxry-compare]");
    var noteCut = $("[data-lxry-note-cut]");
    var noteRow = $("[data-lxry-note-row]");
    var noteAvail = $("[data-lxry-note-avail]");

    /* ---------- Theme-Anbindung ---------- */
    function variantSelects() {
      return document.querySelector(
        'variant-selects[data-section="' + sectionId + '"]'
      );
    }
    function getPageOption(optName) {
      var vs = variantSelects();
      if (!vs) return null;
      var radios = Array.prototype.slice.call(
        vs.querySelectorAll('input[type="radio"]')
      ).filter(function (r) {
        return r.name === optName;
      });
      for (var i = 0; i < radios.length; i++) {
        if (radios[i].checked) return radios[i].value;
      }
      var sels = Array.prototype.slice.call(vs.querySelectorAll("select")).filter(
        function (s) {
          return s.name === "options[" + optName + "]";
        }
      );
      if (sels[0]) return sels[0].value;
      return null;
    }
    /* Mehrere Optionen der PDP setzen und GENAU EIN change-Event feuern
       (= genau eine Variantenkette im Theme statt einer pro Option). */
    function setPageOptions(map) {
      var vs = variantSelects();
      if (!vs) return false;
      var lastEl = null;
      Object.keys(map).forEach(function (optName) {
        var value = map[optName];
        var radios = Array.prototype.slice.call(
          vs.querySelectorAll('input[type="radio"]')
        ).filter(function (r) {
          return r.name === optName;
        });
        if (radios.length) {
          radios.forEach(function (r) {
            if (r.value === value && !r.checked) {
              r.checked = true;
              lastEl = r;
            }
          });
          return;
        }
        var sel = Array.prototype.slice.call(vs.querySelectorAll("select")).filter(
          function (s) {
            return s.name === "options[" + optName + "]";
          }
        )[0];
        if (sel && sel.value !== value) {
          sel.value = value;
          lastEl = sel;
        }
      });
      if (lastEl) lastEl.dispatchEvent(new Event("change", { bubbles: true }));
      return true;
    }

    /* ---------- Variantenauflösung ---------- */
    function findVariant(wood, sizeValue, felt) {
      var wi = optIndex[woodName];
      var si = optIndex[sizeName];
      var fi = feltName != null ? optIndex[feltName] : -1;
      for (var i = 0; i < variants.length; i++) {
        var o = variants[i].options || [];
        if (o[wi] !== wood) continue;
        if (o[si] !== sizeValue) continue;
        if (fi >= 0 && felt != null && o[fi] !== felt) continue;
        return variants[i];
      }
      return null;
    }
    /* Stückpreis (Cent) für Länge + aktuelle Holzart/Filz */
    function priceCentsForLen(len, wood, felt) {
      var sv = sizeValueByLen[len];
      if (sv == null) return null;
      var v = findVariant(wood, sv, felt);
      return v ? v.price : null;
    }

    /* ---------- Zustand ---------- */
    var state = {
      W: 420,
      H: 240,
      wood: null,
      felt: null,
    };
    var lastDrawKey = "";
    var svgRendered = false;

    function currentWood() {
      return state.wood || (toneDots[0] && toneDots[0].getAttribute("data-lxry-wood"));
    }

    /* ---------- Kernrechnung ---------- */
    function compute() {
      var W = Math.max(40, Math.min(1500, parseNum(wInput.value, 40)));
      var H = Math.max(40, Math.min(600, parseNum(hInput.value, 40)));
      var wood = currentWood();
      var felt = state.felt;
      var cols = Math.ceil(W / PW);

      /* Längenwahl über Kostenvergleich */
      var best = null;
      lengths.forEach(function (len) {
        var price = priceCentsForLen(len, wood, felt);
        if (price == null) return;
        var rows = Math.ceil(H / len);
        var n = cols * rows;
        var goods = n * price; // Cent
        var waste = n * PW * len - W * H; // cm² Verschnitt
        var cand = { len: len, rows: rows, n: n, price: price, goods: goods, waste: waste };
        if (
          best === null ||
          cand.goods < best.goods ||
          (cand.goods === best.goods && cand.waste < best.waste) ||
          (cand.goods === best.goods && cand.waste === best.waste && cand.len < best.len)
        ) {
          best = cand;
        }
      });
      if (best === null) {
        return { W: W, H: H, wood: wood, felt: felt, unavailable: true, cols: cols };
      }

      var len = best.len;
      var rows = best.rows;
      var n = best.n;
      var priceCents = best.price;
      var lastW = W - (cols - 1) * PW;
      var lastH = H - (rows - 1) * len;
      var goodsCents = n * priceCents;
      var goodsEuro = goodsCents / 100;
      var base = shipBaseFor(len);
      var ship = goodsEuro >= thFree ? 0 : goodsEuro >= thHalf ? base / 2 : base;

      var targetVariant = findVariant(wood, sizeValueByLen[len], felt);
      var available = targetVariant ? targetVariant.available !== false : false;

      return {
        W: W,
        H: H,
        wood: wood,
        felt: felt,
        cols: cols,
        rows: rows,
        len: len,
        lastW: lastW,
        lastH: lastH,
        n: n,
        priceCents: priceCents,
        goodsCents: goodsCents,
        goodsEuro: goodsEuro,
        base: base,
        ship: ship,
        totalEuro: goodsEuro + ship,
        available: available,
        targetVariant: targetVariant,
      };
    }

    /* ---------- Vorschau (SVG) ---------- */
    function draw(d, animate) {
      var padT = 42,
        padS = 26,
        padB = 30,
        gapH = 45,
        manW = 52,
        manH = 176;
      var sceneW = d.W + gapH + manW;
      var sceneH = Math.max(d.H, manH);
      var y0 = sceneH - d.H;
      var vb = [-padS, -padT, sceneW + padS * 2, sceneH + padT + padB].join(" ");
      var tone = woodColor(d.wood);
      var s = [
        '<svg viewBox="' +
          vb +
          '" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Maßstabsgetreue Vorschau der Paneelaufteilung">',
      ];

      s.push(
        '<line class="lxc-floor" x1="' +
          (-padS + 6) +
          '" y1="' +
          sceneH +
          '" x2="' +
          (sceneW + padS - 6) +
          '" y2="' +
          sceneH +
          '"/>'
      );
      s.push(
        '<line class="lxc-dim" x1="0" y1="' +
          (y0 - 20) +
          '" x2="' +
          d.W +
          '" y2="' +
          (y0 - 20) +
          '"/>'
      );
      s.push(
        '<line class="lxc-dim" x1="0" y1="' +
          (y0 - 26) +
          '" x2="0" y2="' +
          (y0 - 14) +
          '"/>'
      );
      s.push(
        '<line class="lxc-dim" x1="' +
          d.W +
          '" y1="' +
          (y0 - 26) +
          '" x2="' +
          d.W +
          '" y2="' +
          (y0 - 14) +
          '"/>'
      );
      s.push(
        '<text class="lxc-dimtxt" x="' +
          d.W / 2 +
          '" y="' +
          (y0 - 27) +
          '" text-anchor="middle">' +
          d.W +
          " cm</text>"
      );

      var i = 0;
      for (var r = 0; r < d.rows; r++) {
        var py = y0 + r * d.len;
        var ph = Math.min(d.len, d.H - r * d.len);
        for (var c = 0; c < d.cols; c++) {
          var pw = c === d.cols - 1 ? d.lastW : PW;
          var px = c * PW;
          var style = animate
            ? "animation-delay:" + (i * 0.045).toFixed(2) + "s"
            : "animation:none;opacity:1";
          s.push('<g class="lxc-panel" style="' + style + '">');
          s.push(
            '<rect x="' +
              px +
              '" y="' +
              py +
              '" width="' +
              pw +
              '" height="' +
              ph +
              '" fill="' +
              tone +
              '"/>'
          );
          /* Lamellen gleichmäßig, kein angeschnittener Streifen an der Kante */
          for (var k = 1; k < slatsPerPanel; k++) {
            var lx = px + k * effPitch;
            if (lx >= px + pw - 0.5) break;
            s.push(
              '<line class="lxc-slat" x1="' +
                lx +
                '" y1="' +
                (py + 1) +
                '" x2="' +
                lx +
                '" y2="' +
                (py + ph - 1) +
                '"/>'
            );
          }
          s.push(
            '<rect class="lxc-pedge" x="' +
              px +
              '" y="' +
              py +
              '" width="' +
              pw +
              '" height="' +
              ph +
              '" fill="none"/>'
          );
          s.push("</g>");
          i++;
        }
      }

      if (d.lastW < PW - 0.5) {
        var cx = (d.cols - 1) * PW;
        s.push(
          '<line class="lxc-cut" x1="' +
            cx +
            '" y1="' +
            (y0 - 4) +
            '" x2="' +
            cx +
            '" y2="' +
            (sceneH + 4) +
            '"/>'
        );
      }

      var mx = d.W + gapH + manW / 2;
      s.push(
        '<g class="lxc-human" transform="translate(' +
          mx +
          "," +
          (sceneH - manH) +
          ')">' +
          '<circle cx="0" cy="15" r="14" fill="none"/><path d="M0 29 V 104"/>' +
          '<path d="M-22 48 L0 40 L22 48"/><path d="M0 104 L-17 176 M0 104 L17 176"/></g>'
      );
      s.push(
        '<text class="lxc-dimtxt" x="' +
          mx +
          '" y="' +
          (sceneH + 21) +
          '" text-anchor="middle">1,76 m</text>'
      );
      s.push("</svg>");
      wallEl.innerHTML = s.join("");
    }

    /* ---------- Render ---------- */
    function render() {
      var d = compute();

      /* Vorschau nur bei relevanter Änderung neu animieren */
      var key = d.cols + "|" + d.rows + "|" + (d.len || 0) + "|" + d.wood;
      if (svgRendered) {
        if (!d.unavailable) {
          draw(d, key !== lastDrawKey);
          lastDrawKey = key;
        }
      }

      if (d.unavailable) {
        elCount.textContent = "–";
        elFmt.textContent = "";
        elGoods.textContent = "";
        if (elCompare) {
          elCompare.textContent = "";
          elCompare.classList.add("lxry-calc__note--hidden");
        }
        elTotal.textContent = "";
        elArea.textContent = "";
        elM2.textContent = "";
        elShip.textContent = "";
        setNoteAvail(true);
        applyBtn.disabled = true;
        applyTxt.textContent = "Nicht verfügbar";
        switchEl.classList.add("lxry-calc__switch--hidden");
        return;
      }

      elCount.textContent = String(d.n);
      elCountLabel.textContent = d.n === 1 ? "Paneel" : "Paneele";
      var areaM2 = d.n * (d.len / 100) * (PW / 100);
      elArea.textContent = num2.format(areaM2) + " m²";
      elFmt.textContent = d.n + " × " + d.len + " × " + PW + " cm";
      elGoods.textContent = euro(currency, d.goodsCents);

      /* Streichpreis nur zeigen, wenn compare_at_price tatsächlich > price */
      if (elCompare) {
        var cmp =
          d.targetVariant && d.targetVariant.compare_at_price
            ? d.targetVariant.compare_at_price
            : 0;
        if (cmp > d.priceCents) {
          elCompare.textContent = euro(currency, d.n * cmp);
          elCompare.classList.remove("lxry-calc__note--hidden");
        } else {
          elCompare.textContent = "";
          elCompare.classList.add("lxry-calc__note--hidden");
        }
      }

      /* Preis pro m² — reine Anzeige, aus dem Variantenpreis abgeleitet */
      var panelAreaM2 = (d.len / 100) * (PW / 100);
      var m2Cents = Math.round(d.priceCents / panelAreaM2);
      elM2.textContent = euro(currency, m2Cents) + " / m²";

      elShipLabel.textContent =
        d.ship === 0
          ? "Spedition"
          : d.ship < d.base
          ? "Spedition (50 %)"
          : "Spedition";
      elShip.textContent = d.ship === 0 ? "inklusive" : euro(currency, Math.round(d.ship * 100));
      elTotal.textContent = euro(currency, Math.round(d.totalEuro * 100));

      applyTxt.textContent =
        d.n + (d.n === 1 ? " Paneel" : " Paneele") + " in den Warenkorb";

      /* Verfügbarkeit */
      if (!d.available) {
        setNoteAvail(true);
        applyBtn.disabled = true;
        applyTxt.textContent = "Nicht verfügbar";
      } else {
        setNoteAvail(false);
        applyBtn.disabled = false;
      }

      /* Zuschnitt-Hinweis */
      if (d.lastW < PW - 0.5) {
        noteCut.className = "lxry-calc__note lxry-calc__note--warn";
        noteCut.innerHTML =
          "<b>Ein Randpaneel auf " +
          Math.round(d.lastW) +
          " cm kürzen.</b> Das Reststück von " +
          Math.round(PW - d.lastW) +
          " cm passt oft in eine Nische oder als Regalrückwand.";
      } else {
        noteCut.className = "lxry-calc__note lxry-calc__note--hidden";
        noteCut.textContent = "";
      }

      /* Reihen-/Höhen-Hinweis */
      if (d.rows > 1) {
        noteRow.className = "lxry-calc__note lxry-calc__note--warn";
        noteRow.innerHTML =
          "<b>" +
          d.H +
          " cm ergeben zwei Reihen</b> mit einer sichtbaren Querfuge. Sprich uns vorher an — meist lässt sich das mit einer Sonderlänge lösen.";
      } else if (d.lastH < d.len - 0.5) {
        noteRow.className = "lxry-calc__note";
        noteRow.innerHTML =
          "Format " +
          d.len +
          " cm passt: alle Paneele werden auf " +
          d.H +
          " cm gekürzt, eine Schnittkante unten.";
      } else {
        noteRow.className = "lxry-calc__note";
        noteRow.innerHTML = "Format " + d.len + " cm passt exakt — kein Zuschnitt in der Höhe.";
      }

      /* Format-Wechsel-Transparenz */
      updateSwitchHint(d);
    }

    function setNoteAvail(show) {
      if (show) {
        noteAvail.className = "lxry-calc__note lxry-calc__note--avail";
        noteAvail.textContent =
          "Diese Kombination ist derzeit nicht verfügbar. Bitte Holzton oder Maße anpassen.";
      } else {
        noteAvail.className = "lxry-calc__note lxry-calc__note--hidden";
        noteAvail.textContent = "";
      }
    }

    function updateSwitchHint(d) {
      var pageSize = getPageOption(sizeName);
      var pageLen = parseLen(pageSize);
      if (!isFinite(pageLen) || pageLen === d.len) {
        switchEl.classList.add("lxry-calc__switch--hidden");
        switchEl.textContent = "";
        return;
      }
      var curPrice = priceCentsForLen(pageLen, d.wood, d.felt);
      if (curPrice == null) {
        switchEl.classList.add("lxry-calc__switch--hidden");
        return;
      }
      var diffCents = Math.abs(d.n * (curPrice - d.priceCents));
      if (diffCents === 0) {
        switchEl.classList.add("lxry-calc__switch--hidden");
        return;
      }
      var cheaper = d.priceCents < curPrice;
      switchEl.classList.remove("lxry-calc__switch--hidden");
      switchEl.textContent =
        "Wechselt auf " +
        d.len +
        " × " +
        PW +
        " cm — " +
        euro(currency, diffCents) +
        (cheaper ? " günstiger" : " teurer") +
        " als " +
        pageLen +
        " × " +
        PW +
        " cm.";
    }

    /* ---------- Holzton-Dots ---------- */
    function paintDots() {
      toneDots.forEach(function (dot) {
        var w = dot.getAttribute("data-lxry-wood");
        dot.style.setProperty("--_swatch", woodColor(w));
      });
    }
    /* Holzton wechselt nur den Rechnerzustand. Die PDP wird NICHT pro Klick
       umgestellt (jede Umstellung = komplette Variantenkette), sondern
       einmalig nach dem Warenkorb-Add (syncPageAfterAdd). */
    function setActiveTone(woodValue) {
      state.wood = woodValue;
      toneDots.forEach(function (dot) {
        var on = dot.getAttribute("data-lxry-wood") === woodValue;
        dot.classList.toggle("is-on", on);
        dot.setAttribute("aria-checked", on ? "true" : "false");
      });
      if (toneNameEl) toneNameEl.textContent = woodValue || "";
      render();
    }

    /* ---------- Presets ---------- */
    (function buildPresets() {
      var raw = config.presets || "";
      var made = 0;
      String(raw)
        .split("\n")
        .forEach(function (line) {
          var parts = line.split("|");
          if (parts.length >= 3) {
            var name = parts[0].trim();
            var w = parseNum(parts[1], NaN);
            var h = parseNum(parts[2], NaN);
            if (name && isFinite(w) && isFinite(h)) {
              var chip = document.createElement("button");
              chip.type = "button";
              chip.className = "lxry-calc__chip";
              chip.textContent = name;
              chip.setAttribute("data-w", w);
              chip.setAttribute("data-h", h);
              chip.addEventListener("click", function () {
                root.querySelectorAll(".lxry-calc__chip").forEach(function (c) {
                  c.classList.remove("is-on");
                });
                chip.classList.add("is-on");
                wInput.value = w;
                hInput.value = h;
                render();
              });
              presetsWrap.appendChild(chip);
              made++;
            }
          }
        });
      if (!made && presetsWrap) presetsWrap.style.display = "none";
    })();

    /* ---------- Sheet öffnen/schließen ---------- */
    var lastFocus = null;
    function lockScroll() {
      if (typeof window.disablePageScroll === "function") window.disablePageScroll();
      else {
        state._sy = window.pageYOffset || 0;
        document.body.style.top = -state._sy + "px";
        document.body.style.position = "fixed";
        document.body.style.width = "100%";
      }
    }
    function unlockScroll() {
      if (typeof window.enablePageScroll === "function") window.enablePageScroll();
      else {
        document.body.style.position = "";
        document.body.style.top = "";
        document.body.style.width = "";
        window.scrollTo(0, state._sy || 0);
      }
    }
    function openSheet() {
      lastFocus = document.activeElement;
      /* aktuellen Zustand von der Seite lesen */
      var pageWood = getPageOption(woodName);
      state.felt = feltName ? getPageOption(feltName) : null;

      backdrop.hidden = false;
      sheet.hidden = false;
      lockScroll();

      requestAnimationFrame(function () {
        backdrop.classList.add("is-open");
        sheet.classList.add("is-open");
        svgRendered = true;
        lastDrawKey = "";
        setActiveTone(pageWood || currentWood());
        if (typeof window.trapFocus === "function") {
          window.trapFocus(sheet, closeBtn);
        } else if (closeBtn) {
          closeBtn.focus();
        }
      });
    }
    function closeSheet() {
      backdrop.classList.remove("is-open");
      sheet.classList.remove("is-open");
      unlockScroll();
      if (typeof window.removeTrapFocus === "function") {
        window.removeTrapFocus(lastFocus || openBtn);
      } else if (lastFocus) {
        lastFocus.focus();
      }
      setTimeout(function () {
        sheet.hidden = true;
        backdrop.hidden = true;
      }, 400);
    }

    /* ---------- Direkt in den Warenkorb ---------- */
    var adding = false;

    function feltForAdd() {
      /* Filzfarbe hat im Rechner keine eigene Auswahl → aktuelle PDP-Auswahl.
         Nie raten: ohne eindeutige Filzfarbe wird nichts in den Warenkorb gelegt. */
      if (feltName == null) return { ok: true, value: null };
      var f = state.felt || getPageOption(feltName);
      return f ? { ok: true, value: f } : { ok: false, value: null };
    }
    var addError = null; /* Meldung überlebt das render() nach dem Add-Vorgang */
    function showAddError(msg) {
      addError = msg;
      noteAvail.className = "lxry-calc__note lxry-calc__note--avail";
      noteAvail.textContent = msg;
    }
    function setAdding(on, btn, busyText) {
      adding = on;
      if (on) addError = null;
      [applyBtn, sampleBtn].forEach(function (b) {
        if (!b) return;
        b.disabled = on;
        b.setAttribute("aria-busy", on ? "true" : "false");
      });
      if (on) {
        if (btn === applyBtn) applyTxt.textContent = busyText;
      } else {
        render(); /* stellt Text + Verfügbarkeit des Apply-Buttons wieder her */
        if (addError) showAddError(addError);
      }
    }
    function cartSections() {
      var drawer = document.getElementById("Cart-Drawer");
      var active = !!drawer && !drawer.hasAttribute("data-status-silence");
      var sections = [
        { id: "Cart-Icon-Bubble", section: "cart-icon-bubble", selector: ".shopify-section" },
      ];
      if (active) {
        sections.push({
          id: "Cart-Drawer",
          section: drawer.dataset.section,
          selector: "#Cart-Drawer-Details",
        });
      }
      return { drawer: drawer, active: active, list: sections };
    }
    /* PDP einmalig auf die gewählte Variante stellen (Konsistenz/URL).
       Läuft NACH dem Warenkorb-Add, zeitlich entkoppelt, und ändert weder
       Warenkorb noch Menge des Add-Vorgangs. */
    function syncPageAfterAdd(map) {
      setTimeout(function () {
        try {
          setPageOptions(map);
        } catch (e) {
          /* PDP-Sync ist rein kosmetisch */
        }
      }, 700);
    }
    /* Variante-ID + Menge kommen ausschließlich aus dem Rechnerzustand —
       unabhängig vom Zustand der PDP. Gleicher Endpunkt/gleiche Header wie
       assets/product-form.js, damit Shopify-Pixel (add_to_cart) genau
       einmal feuern. */
    function addToCart(variant, qty, btn, busyText, pageMap) {
      if (adding) return;
      if (!variant || !(qty > 0)) {
        showAddError("Diese Kombination ist derzeit nicht verfügbar. Bitte Holzton oder Maße anpassen.");
        return;
      }
      var routes = window.routes || {};
      if (!routes.cart_add_url || typeof window.fetchConfig !== "function") {
        showAddError("Warenkorb nicht verfügbar. Bitte Seite neu laden.");
        return;
      }
      setAdding(true, btn, busyText);
      setNoteAvail(false);

      var cs = cartSections();
      var cfg = window.fetchConfig("javascript");
      cfg.headers["X-Requested-With"] = "XMLHttpRequest";
      delete cfg.headers["Content-Type"]; /* Boundary setzt der Browser */
      var body = new FormData();
      body.append("form_type", "product");
      body.append("utf8", "✓");
      body.append("id", String(variant.id));
      body.append("quantity", String(qty));
      /* Vorbestellung: gleiche Kennzeichnung wie das PDP-Formular */
      var pre = document.querySelector(
        'input[name="properties[Sale type]"][form="' + config.formId + '"]'
      );
      if (pre) body.append("properties[Sale type]", pre.value);
      body.append(
        "sections",
        cs.list
          .map(function (s) {
            return s.section;
          })
          .join()
      );
      body.append("sections_url", window.location.pathname);
      cfg.body = body;

      fetch(routes.cart_add_url, cfg)
        .then(function (r) {
          return r.json();
        })
        .then(function (res) {
          if (res && res.status) {
            showAddError(
              res.description || res.message || "Konnte nicht hinzugefügt werden. Bitte erneut versuchen."
            );
            if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "lxry-calc",
                productVariantId: variant.id,
                errors: res.errors || res.description,
                message: res.message,
              });
            }
            return;
          }
          if (typeof SectionDynamicUpdate !== "undefined" && res.sections) {
            SectionDynamicUpdate.updateSections(cs.list, res.sections);
          }
          if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: "lxry-calc",
              productVariantId: variant.id,
              cartData: res,
            });
          }
          closeSheet();
          if (cs.active) cs.drawer.show(btn);
          else window.location = routes.cart_url;
          if (pageMap) syncPageAfterAdd(pageMap);
        })
        .catch(function () {
          showAddError("Netzwerkfehler. Bitte erneut versuchen.");
        })
        .then(function () {
          setAdding(false);
        });
    }
    /* ---------- X Paneele in den Warenkorb ---------- */
    function applyToForm() {
      if (adding) return;
      var d = compute();
      if (d.unavailable || !d.available || !d.targetVariant) return;
      var felt = feltForAdd();
      if (!felt.ok) {
        showAddError("Bitte zuerst oben die Filzfarbe wählen.");
        return;
      }
      /* Variante aus Rechnerzustand (Holzton × Länge × Filz), nie aus der PDP */
      var variant = findVariant(d.wood, sizeValueByLen[d.len], felt.value);
      var map = {};
      map[woodName] = d.wood;
      map[sizeName] = sizeValueByLen[d.len];
      addToCart(variant, d.n, applyBtn, "Wird hinzugefügt …", map);
    }

    /* ---------- Muster-Ausstieg: Muster der gewählten Holzart/Filzfarbe ---------- */
    function orderSample() {
      if (adding || !musterSizeValue) return;
      var felt = feltForAdd();
      if (!felt.ok) {
        showAddError("Bitte zuerst oben die Filzfarbe wählen.");
        return;
      }
      var wood = currentWood();
      var variant = findVariant(wood, musterSizeValue, felt.value);
      /* Menge zwingend 1 — nie Muster mit Menge > 1. PDP-Sync nur Holzart
         (die Hauptgröße der PDP bleibt unverändert). */
      var map = {};
      map[woodName] = wood;
      addToCart(variant, 1, sampleBtn, "", map);
    }

    /* ---------- Events ---------- */
    openBtn.addEventListener("click", openSheet);
    closeBtn.addEventListener("click", closeSheet);
    backdrop.addEventListener("click", closeSheet);
    applyBtn.addEventListener("click", applyToForm);
    if (sampleBtn) sampleBtn.addEventListener("click", orderSample);

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && sheet.classList.contains("is-open")) closeSheet();
    });

    [wInput, hInput].forEach(function (input) {
      input.addEventListener("input", function () {
        root.querySelectorAll(".lxry-calc__chip").forEach(function (c) {
          c.classList.remove("is-on");
        });
        render();
      });
    });

    toneDots.forEach(function (dot) {
      dot.addEventListener("click", function () {
        setActiveTone(dot.getAttribute("data-lxry-wood"));
      });
    });

    /* Seite → Sheet: Holzart/Filz-Wechsel auf der PDP spiegeln */
    var vs = variantSelects();
    if (vs) {
      vs.addEventListener("change", function () {
        if (!sheet.classList.contains("is-open")) return;
        var pageWood = getPageOption(woodName);
        state.felt = feltName ? getPageOption(feltName) : null;
        if (pageWood && pageWood !== state.wood) {
          setActiveTone(pageWood);
        } else {
          render();
        }
      });
    }

    /* Init-Zustand (ohne Sheet zu öffnen) */
    paintDots();
    state.wood = getPageOption(woodName) || (toneDots[0] && toneDots[0].getAttribute("data-lxry-wood"));
    state.felt = feltName ? getPageOption(feltName) : null;
    if (toneNameEl) toneNameEl.textContent = state.wood || "";
    toneDots.forEach(function (dot) {
      var on = dot.getAttribute("data-lxry-wood") === state.wood;
      dot.classList.toggle("is-on", on);
      dot.setAttribute("aria-checked", on ? "true" : "false");
    });
  }

  function initAll() {
    document.querySelectorAll("[data-lxry-calc]").forEach(function (root) {
      initRoot(root);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})();
